var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3516_56390)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 1.95703H3.5C3.10218 1.95703 2.72064 2.11507 2.43934 2.39637C2.15804 2.67768 2 3.05921 2 3.45703V21.457C2 21.8549 2.15804 22.2364 2.43934 22.5177C2.72064 22.799 3.10218 22.957 3.5 22.957H21.5C21.8978 22.957 22.2794 22.799 22.5607 22.5177C22.842 22.2364 23 21.8549 23 21.457V3.45703C23 3.05921 22.842 2.67768 22.5607 2.39637C22.2794 2.11507 21.8978 1.95703 21.5 1.95703ZM3.5 0.457031C2.70435 0.457031 1.94129 0.773102 1.37868 1.33571C0.816071 1.89832 0.5 2.66138 0.5 3.45703L0.5 21.457C0.5 22.2527 0.816071 23.0157 1.37868 23.5784C1.94129 24.141 2.70435 24.457 3.5 24.457H21.5C22.2956 24.457 23.0587 24.141 23.6213 23.5784C24.1839 23.0157 24.5 22.2527 24.5 21.457V3.45703C24.5 2.66138 24.1839 1.89832 23.6213 1.33571C23.0587 0.773102 22.2956 0.457031 21.5 0.457031L3.5 0.457031Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.45703C12.6989 6.45703 12.8897 6.53605 13.0303 6.6767C13.171 6.81735 13.25 7.00812 13.25 7.20703V11.707H17.75C17.9489 11.707 18.1397 11.786 18.2803 11.9267C18.421 12.0674 18.5 12.2581 18.5 12.457C18.5 12.6559 18.421 12.8467 18.2803 12.9874C18.1397 13.128 17.9489 13.207 17.75 13.207H13.25V17.707C13.25 17.9059 13.171 18.0967 13.0303 18.2374C12.8897 18.378 12.6989 18.457 12.5 18.457C12.3011 18.457 12.1103 18.378 11.9697 18.2374C11.829 18.0967 11.75 17.9059 11.75 17.707V13.207H7.25C7.05109 13.207 6.86032 13.128 6.71967 12.9874C6.57902 12.8467 6.5 12.6559 6.5 12.457C6.5 12.2581 6.57902 12.0674 6.71967 11.9267C6.86032 11.786 7.05109 11.707 7.25 11.707H11.75V7.20703C11.75 7.00812 11.829 6.81735 11.9697 6.6767C12.1103 6.53605 12.3011 6.45703 12.5 6.45703Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3516_56390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.457031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.aa0cbc2bc3aab11878b69d240df3f9f3.svg";
export { ForwardRef as ReactComponent };